import * as React from "react";
const SvgNoData = (props) => /* @__PURE__ */ React.createElement("svg", { width: 120, height: 96, viewBox: "0 0 120 96", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 24, y: 10, width: 56, height: 72, rx: 5, style: {
  fill: "rgb(var(--landing-white, 255 255 255))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M34 24H70M34 34H62M34 44H66", style: {
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2, strokeLinecap: "round", strokeDasharray: "4 5" }), /* @__PURE__ */ React.createElement("circle", { cx: 74, cy: 56, r: 16, style: {
  fill: "rgb(var(--landing-surface, 251 248 242))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2.5 }), /* @__PURE__ */ React.createElement("path", { d: "M86 68L98 80", style: {
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 4, strokeLinecap: "round" }));
export default SvgNoData;
